import { useState } from "react";
import { useEffect } from "react";
import { FaArrowRight } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa";
import GlobalStyle from "./styles/Global";
import api from "./services/api";
import { Title } from "./components/Title";
import { Characters } from "./components/Characters";
import { Button } from "./components/Button";
import background from "./images/background.png";
import "./App.css";

function App() {
  const [characterList, setCharacterList] = useState([]);
  const [page, setPage] = useState(1);
  const [isNextDisable, setIsNextDisable] = useState(false);
  const [isPrevDisable, setIsPrevDisable] = useState(true);

  useEffect(() => {
    api
      .get(`character/?page=${page}`)
      .then((response) => {
        const { results, info } = response.data;

        setCharacterList(results);
        setIsNextDisable(!info.next);
        setIsPrevDisable(!info.prev);
      })
      .catch((error) => console.log(error));
  }, [page, isNextDisable, isPrevDisable]);

  return (
    <div className="App" style={{ backgroundImage: `url(${background})` }}>
      <GlobalStyle />
      <div className="container">
        <Title />
        <div className="button-container">
          <Button onClick={() => setPage(page - 1)} disabled={isPrevDisable}>
            <FaArrowLeft className="icon-page" />
            Previous
          </Button>
          <Button onClick={() => setPage(page + 1)} disabled={isNextDisable}>
            Next
            <FaArrowRight className="icon-page" />
          </Button>
        </div>
        <Characters characterList={characterList}></Characters>
        <div className="button-container">
          <Button onClick={() => setPage(page - 1)} disabled={isPrevDisable}>
            <FaArrowLeft className="icon-page" />
            Previous
          </Button>
          <Button onClick={() => setPage(page + 1)} disabled={isNextDisable}>
            Next
            <FaArrowRight className="icon-page" />
          </Button>
        </div>
      </div>
    </div>
  );
}

export default App;
